<template>
  <div />
</template>
<script>
import { loginuser } from '@/api/loginToC'
import { setToken } from '@/utils/auth'
import { thirdAuthUrl } from '@/api/loginToB.js'
import Cookies from 'js-cookie'

const CIAM = 'CIAM'
const MEID = 'MEID'
const CIAM_COOKIE_KEY = 'CIAM_RESPONSE_DATA'

export default {
  name: 'CiamLogin',
  created() {
    this.simulateLogin()
  },
  methods: {
    // 代理登录
    simulateLogin() {
      const phone = this.getPhoneFromCiamResponse()
      if (phone) {
        loginuser(phone).then(res => {
          const newtoken = res.access_token
          setToken(newtoken)
          localStorage.setItem('source', CIAM)
          localStorage.setItem(MEID, this.getMeidFromCiamResponse())
          this.$router.push({ name: 'UserHome' })
        })
      } else {
        console.log('ciamLogin.vue')
        thirdAuthUrl({ target: 'ciam', type: 'LOGIN' }).then(url => { window.location = url })
      }
    },
    // 获取cookice里的用户手机号
    getPhoneFromCiamResponse() {
      const ciamResponseCookie = Cookies.get(CIAM_COOKIE_KEY)
      if (ciamResponseCookie) {
        const userInfo = JSON.parse(ciamResponseCookie)
        return userInfo.user.mobile
      } else {
        return ''
      }
    },
    // 获取cookice里的token
    getMeidFromCiamResponse() {
      const ciamResponseCookie = Cookies.get(CIAM_COOKIE_KEY)
      if (ciamResponseCookie) {
        const userInfo = JSON.parse(ciamResponseCookie)
        // const externalKeys = userInfo.user.externalKeys
        // const ciamKey = externalKeys.filter(k => k.system === CIAM)
        // return ciamKey.length > 0 ? ciamKey[0].id : ''
        const ciamKey = userInfo.user.uid
        return ciamKey
      } else {
        return ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/login/ciamLogin.vue